import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { distributorService } from "services/distributor.api";
import { selectDistributorItems } from "store/distributorSlice";
import { setDistributorItems } from "store/distributorSlice";

const useDistributor = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const distributorList = useSelector(selectDistributorItems);
  const [error, setError] = useState(null);

  const getdistributorList = async (data) => {
    setLoading(true);
    try {
      const response = await distributorService.fetchList(data);
      if (response.success) {
        dispatch(setDistributorItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const createdistributor = async (payload) => {
    setLoading(true);
    try {
      const response = await distributorService.createDistributor(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const updatedistributor = async (id, payload) => {
    setLoading(true);
    try {
      const response = await distributorService.updateDistributor(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const deletedistributor = async (id) => {
    setLoading(true);
    try {
      const response = await distributorService.deleteDistributor(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getdistributorById = async (id) => {
    setLoading(true);
    try {
      const response = await distributorService.fetchDistributorById(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getDistributorOptions = async () => {
    setLoading(true);
    try {
      const response = await distributorService.fetchDistributorOptions();
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getdistributorList,
    distributorList,
    createdistributor,
    getdistributorById,
    deletedistributor,
    updatedistributor,
    getDistributorOptions,
    loading,
    error,
  };
};

export default useDistributor;
